import makeUniqueId from 'helpers/makeUniqueId'
import http_request from 'sync/http_raw'

let _metricId = makeUniqueId()
const _sessionId = makeUniqueId()
const pendingMetrics = []

const submitMetric = async data => http_request
	.post('https://metrics.nearpod.com/google.slides')
	.send(data)

const submitNextMetric = async () => {
	if (pendingMetrics.length) {
		const nextMetric = pendingMetrics.shift()
		await submitMetric(nextMetric)
		submitNextMetric()
	}
}

const initialize = () => {
	_metricId = makeUniqueId()
}


const add = data => {
	data._metricId = _metricId
	data._sessionId = _sessionId
	pendingMetrics.push(data)
	if (pendingMetrics.length === 1) {
		submitNextMetric()
	}
}

export default {
	initialize,
	add,
}
